<template>
  <el-drawer
    title=" "
    size="230"
    :visible.sync="show"
    :show-close="false"
    :before-close="() => $emit('close')"
    direction="btt">
    <div class="drawer-content not-select">
      <div class="flex-between-center" style="margin-bottom: 10px">
        <div></div>
        <div>分享至</div>
        <i class="el-icon-close" @click="$emit('close')"></i>
      </div>
      <div class="icon-group">
        <div v-for="item in shareList" :key="item.title" @click="item.click" v-if="item.disabled(isAuthor)">
          <img :src="item.icon">
          <div style="padding:5px">{{item.title}}</div>
        </div>
      </div>
    </div>

<!--    <el-dialog-->
<!--      :show-close="false"-->
<!--      :visible.sync="showCode"-->
<!--      :before-close="() => showCode = false"-->
<!--    >-->
      <div class="model" v-if="showCode" @click="showCode = false"></div>
      <div class="code-dialog" v-show="showCode" :style="{'left': window.innerWidth * 0.5 - 168 * 0.5 + 'px'}">
        <div style="z-index: 3;display:flex;flex-direction: column;align-items: center">
          <div style="padding: 10px">分享至微信</div>
          <div ref="qrCode" v-if="showCode"></div>
        </div>
      </div>
<!--    </el-dialog>-->
  </el-drawer>
</template>

<script>
    import QrCode from 'qrcodejs2'

    export default {
      name: 'shareTo',
      props: {
        show: {
          type: Boolean,
          default: false
        },
        isAuthor: { // 是否为作者, 只有作者本人才能启用删除按键
          type: Boolean,
          default: false
        },
        toWx: {
          type: Function,
          default: null
        },
        toPyq: {
          type: Function,
          default: null
        },
        toWb: {
          type: Function,
          default: null
        },
        copyPath: {
          type: Function,
          default: null
        },
        reportMain: {
          type: Function,
          default: null
        },
        deleteMain: {
          type: Function,
          default: null
        }
      },
      data () {
        return {
          showCode: false,
          shareList: [
            {
              title: '微信好友',
              disabled: status => false,
              icon: require('../../assets/share-wx.png'),
              click: () => (this.toWx || this._shareToWechart)()
            }, {
              title: '朋友圈',
              disabled: status => false,
              icon: require('../../assets/share-pyq.png'),
              click: () => (this.toPyq || this._toPyq)()
            }, {
              title: '微博',
              disabled: status => true,
              icon: require('../../assets/share-wb.png'),
              click: () => (this.toWb || this._shareToWb)()
            }, {
              title: '复制链接',
              disabled: status => true,
              icon: require('../../assets/share-copyPath.png'),
              click: () => (this.copyPath || this._copyPath)()
            }, {
              title: '举报',
              disabled: status => !status,
              icon: require('../../assets/share-warning.png'),
              click: () => (this.reportMain || new Function() )()
            }, {
              title: '删除',
              disabled: status => !!status,
              icon: require('../../assets/share-delete.png'),
              click: () => (this.deleteMain || new Function() )()
            }
          ]
        }
      },
      methods: {
        uuid: function () {
          function S4() {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
          }
          return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
        },
        // 复制链接
        _copyPath () {
          try {
            var textareaEl = document.createElement('textarea')
            textareaEl.setAttribute('readonly', 'readonly') // 防止手机上弹出软键盘
            textareaEl.value = `${window.location.href}&t=${this.uuid()}&uid=${this.user.userId}`
            document.body.appendChild(textareaEl)
            textareaEl.select();
            var res = document.execCommand('copy')
            document.body.removeChild(textareaEl)
            if (res) {
              this.Toast('复制成功')
            }
            return res
          } catch (e) {
            this.Toast({
              message: e
            })
          }
        },
        _shareToWechart () {
          this.showCode = true
          setTimeout(() => {
            new QrCode(this.$refs.qrCode, {
              text: `${window.location.href}&t=${this.uuid()}&uid=${this.user.userId}`,
              width: 128, height: 128,
              colorDark: '#000',
              colorLight: '#fff'
            })
          })
        },
        // 分享至微博
        _shareToWb () {
          // var title = '检验网'
          // var appKey = '1343713053'
          // var url = `https://service.weibo.com/share/share.php?url=${window.location.href}&title=${title}&appkey=${appKey}&pic=${pic}`
          // window.open(url, 'newwindow')
        },
        _toPyq () {
          this.Toast('暂不支持分享至朋友圈')
        }
      },
      computed: {
        window () {
          return window
        },
        user () {
          return this.$store.state.user
        }
      }
    }
</script>

<style scoped>
  img {
    width: 48px;height:48px
  }
  .drawer-content {
    padding:1.5rem;background: #f5f5f5;
    font-size: 12px;color: #5A5B5C;
  }
  .icon-group {
    display: flex;flex-wrap: wrap;
    justify-content: flex-start;
  }
  .icon-group > div {
    padding:1.2rem 0;
    width:33%;display: flex;
    flex-direction: column;
    align-items: center
  }
  .code-dialog {
    background: #fff;width: 168px;
    display: flex;flex-direction: column;
    align-items: center;padding-bottom: 20px;
    position:fixed;top: 30%
  }
  .model {
    position:fixed;width:100%;
    height:100%;top:0px;
    background: #000;opacity: 0.55
  }
  * /deep/ .el-dialog__header {display: none}
  * /deep/ .el-dialog__wrapper {z-index: 4002}
</style>



// WEBPACK FOOTER //
// src/pages/video/shareTo.vue